import { RecordObject } from 'src/models/general.model';

export const SEARCH_KEYS = ['label'];

export const MATCH_AUTOCOMPLETE_WITH_TYPE: RecordObject<string> = {
  email: 'email',
  password: 'new-password',
};
